import $ from 'jquery';
import StringColumn from './StringColumn';
import {localize} from 'linksoft';
const Resx = localize('Common');

export default class Select2BaseColumn extends StringColumn {



	// -------------- FILTERS --------------------

	getFilterText() {
		return this.getSelect2Filter().select2('data').filter(x => x.id).map(x => x.text).pop() || "";
	}

	setFilterValue(value) {
		this.getSelect2Filter().val(value || '').trigger('change');
	}

	setFilterFocus() {
		setTimeout(() => {
			this.getSelect2Filter().select2("open");
		}, 100);
	}

	getSelect2Filter() {
		return this.column.filter().find('select.table-filter');
	}

	getFilterAllText() {
		return Resx.Common.All;
	}

	showFilterButton() {
		return false;
	}

	onFilterRendered() {
		this.column.filter().find('.filter-box-wrap').css('width', '250px').addClass('filter-box-select');
	}

	// ------------- EDITOR -----------------

	onEditorCreated(cellElement) {
		cellElement.find('select').on('select2:close', e => {
			this.api.editor().submitChanges();
			$(e.target).data('isClosing', true);
		}).on('select2:opening', e => {
			if($(e.target).data('isClosing')){
				return false;
			}
		});
	}
}


// WEBPACK FOOTER //
// ./node_modules/linksoft-datatables/src/renderers/Select2BaseColumn.js